import { NgModule } from '@angular/core';
import { TimeInputComponent } from './time-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { DateModule } from '../../date.module';

@NgModule({
  declarations: [TimeInputComponent],
  imports: [TranslateModule.forChild(), DateModule],
  exports: [TimeInputComponent],
})
export class TimeInputModule {}
